module.exports = __webpack_public_path__ + "img/pluto149.1291a949.jpg";